<template>
  <div class="modal-assign">
    <Modal :config="modal">
      <template v-slot:header>
        <h4 class="title is-4">{{ translations.assign_account }}</h4>
      </template>
      <VueSelect :config="selectAccount" v-model="clientAccountId" @search="onSearch" />

      <template v-slot:footer>
        <button
          class="button is-success"
          :class="{ 'is-loading': loading }"
          :disabled="!clientAccountId"
          @click="submit()"
        >{{ translations.assign_account }} ({{ selected.length }})</button>
      </template>
    </Modal>
  </div>
</template>
<style lang="scss">
.modal-assign .modal-card-body {
  overflow: visible !important;
}
</style>
<script lang="ts">
// @ is an alias to /src
import { searchClientAccounts } from '@/api/clientAccounts';
import { IVSelect } from '@/components/form';
import VueSelect from '@/components/form/vue-select/vue-select.vue';
import Modal from '@/components/modal.vue';
import { IClientAccountLean } from '@/models/clientAccount';
import router from '@/router';
import { IBulkEventsAccount } from '@/store/modules/events';
import { IEventsTranslations } from '@/translations';
import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

import { eventsModal } from './../';

@Component({
  name: 'AssignAccount',
  components: { Modal, VueSelect }
})
class AssignAccount extends Vue {
  @Action('assignAccount') public assign!: (payload: IBulkEventsAccount) => void;

  @Getter('getSelectedEvents') public selected!: number[];

  @Getter('getEventsTranslations') public translations!: IEventsTranslations;
  public clientAccountId = '';
  public selectedAccountName = '';
  public modal = eventsModal;
  public loading = false;
  public accounts: IClientAccountLean[] = [];
  public selectAccount: IVSelect = {
    id: 'select-account',
    label: '',
    placeholder: '',
    value: '',
    options: []
  };
  public searchTimeout: number | null = null;

  public created() {
    this.selectAccount = {
      ...this.selectAccount,
      placeholder: this.translations.account_placeholder,
      onInput: this.onAccountInput
    };
    this.fetchAccounts();
  }

  public onAccountInput(id: string | number) {
    const account = this.accounts.find(account => account.id === id);
    this.selectedAccountName = account ? account.client_name : '';
  }

  public fetchAccounts(search?: string) {
    searchClientAccounts(1, 20, search)
      .then(response => {
        this.accounts = response.data.results;
        this.selectAccount = {
          ...this.selectAccount,
          options: this.accounts.map(account => ({
            value: account.id,
            label: account.client_name
          }))
        };
      })
      .catch(() => {
        this.accounts = [];
      });
  }

  public submit() {
    if (this.clientAccountId === '' || !this.selectedAccountName) {
      return;
    }

    const clientAccountId = parseInt(this.clientAccountId, 10);

    this.loading = true;

    this.assign({
      ids: this.selected,
      client_account: clientAccountId,
      client_account_name: this.selectedAccountName
    });

    router.push('/events');
  }

  public onSearch(value: string) {
    // Clear the previous timeout if it exists
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    // Set a new timeout to execute the search after 1.2 seconds
    this.searchTimeout = window.setTimeout(() => {
      this.fetchAccounts(value);
    }, 1200);
  }

  public close() {
    router.push('/events');
  }

  public beforeDestroy() {
    // Clear timeout on component destroy to prevent memory leaks
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  }
}

export default AssignAccount;
</script>
